export default __webpack_public_path__ + "static/media/image_example_check.0337ce6e.svg";